import { Injectable } from '@angular/core';
import { LangDataService } from './lang-data.service';
import { AppStateService } from './app-state.service';

export type TrackEvent = 'startpage' | 'appliance' | 'design' | 'color' | 'milieu' | 'prewall' | 'result' | 'pdf' | 'mobile';

@Injectable()
export class WebTrekkService {
    private static readonly ConfiguratorId = "flushplate";
    /** The tracking id for test / development domains. */
    private static readonly TrackIdTest = "799424540672764";
    private static readonly TestDomainMatchers = [
        "localhost",
        "vsat-pim-ww-i",
        "emea.dir"
    ];
    private isFirstTrackEvent: boolean = true;
    private isInitialized: boolean = false;

    constructor(
        private lang: LangDataService,
        private appState: AppStateService,
    ) {}

    public initTracker() {
        if (!window["wtSmart"]) {
            console.error('expected wtSmart to be defined when initializing it.');
            return;
        }

        const trackingId = WebTrekkService.isTestDomain() ? WebTrekkService.TrackIdTest : this.lang.getString('webtrekk-tracking-id');
        wtSmart.init.set({
            trackId: trackingId,
            trackDomain: this.lang.getString('webtrekk-tracking-url', 'viegade01.wt-eu02.net'),
        });

        wtSmart.extension.action.activate();
        this.isInitialized = true;
    }

    public trackEvent(eventName: TrackEvent) {
        if (!window["wtSmart"]) {
            console.error('expected wtSmart to be defined when trying to sent a track event.');
            return;
        }

        if(!this.isInitialized) {
            this.initTracker();
        }

        let trackingParameter = {};
        if (this.isFirstTrackEvent) {
            trackingParameter = {
                15: document.referrer,
                16: this.getDefaultLanguageString(),
            };
        }

        const defaultLangId = this.getLanguage();
        var dataObject = {
            parameter: trackingParameter,
            category: {
                1: defaultLangId,
                2: 'web',
                3: 'configurator',
                4: WebTrekkService.ConfiguratorId,
                5: eventName
            }
        };

        // handle internal Website users
        if (window["referrer"] && window["referrer"].length > 0 && (window["referrer"].indexOf('http://') === 0 || window["referrer"].indexOf('https://') === 0) ) {
            dataObject["referrer"] = window["referrer"];
        }
 
        if (window["internal"] && window["internal"] === '1') {
            dataObject["intern"] = "intern";
        }

        wtSmart.page.data.set(`${defaultLangId}.web.configurator.${WebTrekkService.ConfiguratorId}.${eventName}`, dataObject);

        if (!this.isFirstTrackEvent)
            wtSmart.extension.action.reload();

        wtSmart.track();
        this.isFirstTrackEvent = false;
    }

    /**
     * returns the default language string for the tracking pixel
     * example "de_DE"
     */
    public getDefaultLanguageString(): string {
        let defaultLang = this.getLanguage();
        if (defaultLang !== "test")
            defaultLang = this.lang.getString("smartpixel-tracking-default-lang-id");

        return defaultLang;
    }

    /**
     * returns the defaultLanguage
     * in case of a developement system 'test' gets returned
     */
    public getLanguage(): string {
        return WebTrekkService.isTestDomain() ? "test" : this.appState.languageId;
    }

    /**
     * returns a boolean stating if the server runs in a test development environment
     */
    public static isTestDomain(): boolean {
        return WebTrekkService.TestDomainMatchers.some(m => document.URL.indexOf(m) !== -1);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/web-trekk.service.ts